export default "__VITE_ASSET__CvvLAKDh__"